import { getStaticAssetUrl } from '@helper/utils/file'
import cn from '@config/tailwind/cn'

interface NoResultFoundProps {
  type: 'web' | 'school'
  keyword: string
}

export function NoResultFound({ type, keyword }: NoResultFoundProps) {
  return (
    <div
      className={cn(
        'srd:w-full srd:flex srd:flex-col srd:items-center srd:justify-center srd:gap-y-2 srd:h-fit srd:min-h-[40dvh]',
        type === 'web' && 'srd:text-neutrals-white',
      )}
    >
      <img src={getStaticAssetUrl('illustration/kohi.png')} alt='' width={60} height={60} draggable={false} />

      <h6 className='srd:font-medium'>Krik, krik, krik...</h6>

      <p>
        Tidak ada hasil yang ditemukan dengan kata kunci <span className='srd:font-medium'>{keyword}</span>
      </p>
    </div>
  )
}
